<template lang="pug">
.col-md-4.i_mt_4
  .announcement.i_p_6.d-flex.flex-column.justify-content-between
    p.i_body {{ announcement.Title }}
    .date.d-flex.flex-md-column-reverse.align-items-center.align-items-md-start.align-items-lg-center.flex-lg-row
      | {{ announcement.PostDate }}
      svg-icon.i_ml_1.i_ml_md_0.i_ml_sm_1(
        iconClass="contact",
        className="icon",
        v-if="announcement.isNew"
      )
    router-link.see_more_btn.i_mt_2.i_m_6(
      tag="a",
      :to="{ name: 'Detail', query: { type: 'announcement', id: announcement.ID } }"
    ) 更多
</template>

<script>
export default {
  name: "Announcement",
  props: {
    announcement: Object,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/announcement";
</style>
